<div class="agu-seg" role="group" [attr.aria-labelledby]="LabelledBy" [attr.aria-label]="LabelledBy ? null : GroupLabel">
    @for (option of Options; track option.Key) {
        <button type="button" class="agu-seg__btn" [class.agu-seg__btn--on]="IsOn(option)" [attr.aria-pressed]="IsOn(option)" (click)="Pick(option.Key)">{{ option.Label }}</button>
    }
</div>
